import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';

export const setCurrentMandantId =
  (id: number | undefined) => (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_MANDANT_ID,
      payload: id,
    });
  };
